import React from 'react'
import { PartialShoesAction, ShoesState } from 'src/types'
import { TabPanel } from 'src/Components/Ui/TabPanel'
import { SelectCard } from 'src/Components/Ui/SelectCard'
import { TOE_GUARDS, UPPER_MATERIALS, VAMP_STRAP_TYPES, LINE_TYPES } from '../../constants/base'
import { generateShoesDispatcher, getOpeningPatterns, getOutSoles, getSizes, getTongues, getToeGuardKinds } from '../../logic'
import { SelectCardWithImage } from 'src/Components/Ui/SelectCardWithImage'
import { Button } from '@mui/material'
import { SHOES_DISPATCHER } from '../../constants/action'

type Props = {
  state: ShoesState
  selectedIndex: number
  dispatch: React.Dispatch<PartialShoesAction>
}

export const ShoesBaseSetter: React.FC<Props> = ({ state, selectedIndex, dispatch }) => {
  const { upperMaterial, size, openingPattern, vampStrapType, tongue, outSole, lineType, toeGuard, toeGuardKind } = state
  const handle = {
    upperMaterial: generateShoesDispatcher(dispatch)('upperMaterial'),
    size: generateShoesDispatcher(dispatch)('size'),
    openingPattern: generateShoesDispatcher(dispatch)('openingPattern'),
    vampStrapType: generateShoesDispatcher(dispatch)('vampStrapType'),
    tongue: generateShoesDispatcher(dispatch)('tongue'),
    outSole: generateShoesDispatcher(dispatch)('outSole'),
    lineType: generateShoesDispatcher(dispatch)('lineType'),
    toeGuard: generateShoesDispatcher(dispatch)('toeGuard'),
    toeGuardKind: generateShoesDispatcher(dispatch)('toeGuardKind')
  }

  const sizes = getSizes(state)
  const openingPatterns = getOpeningPatterns(state)
  const outSoles = getOutSoles(state)
  const tongues = getTongues(state)
  const toeGuardKinds = getToeGuardKinds(state)
  const isSelectedUpperMaterial = upperMaterial.value !== 'unselected'

  return (
    <TabPanel selectedIndex={selectedIndex} index={0}>
      {process.env.NEXT_PUBLIC_ENV === 'local' && (
        <Button variant="contained" onClick={() => dispatch({ type: SHOES_DISPATCHER.setShoesState })}>
          mock
        </Button>
      )}
      <SelectCard
        summary={'アッパー素材'}
        selectedLabel={upperMaterial.label}
        objects={UPPER_MATERIALS}
        disabled={isSelectedUpperMaterial}
        description={isSelectedUpperMaterial ? '変更するにはシミュレーションをリセットしてください。' : ''}
        isError={upperMaterial.value === 'unselected'}
        handleChange={handle.upperMaterial}
      />
      <SelectCardWithImage
        summary={'ソール'}
        selectedLabel={outSole.label}
        objects={outSoles}
        imageWidth={150}
        imageHeight={70}
        handleChange={handle.outSole}
        isShowLabel
        disabled={size.value !== 'unselected'}
        description={size.value === 'unselected' ? '' : '変更したい場合は、サイズをリセットしてください。'}
        isError={outSole.value === 'unselected'}
      />
      <SelectCard
        summary={'サイズ'}
        selectedLabel={size.label}
        objects={sizes}
        handleChange={handle.size}
        description={'サイズ感（足囲）は"3E"となります。'}
        isError={size.value === 'unselected'}
      />
      <SelectCard
        summary={'甲止めタイプ'}
        selectedLabel={vampStrapType.label}
        objects={VAMP_STRAP_TYPES}
        handleChange={handle.vampStrapType}
        isError={vampStrapType.value === 'unselected'}
      />
      <SelectCard
        summary={'履き口パターン'}
        selectedLabel={openingPattern.label}
        objects={openingPatterns}
        handleChange={handle.openingPattern}
        description={tongue.value === 'foldingTongue' ? `"クォーターカット"は、"立ちベロ"時のみ選択可能です。` : ''}
        isError={openingPattern.value === 'unselected'}
      />
      <SelectCard
        summary={'ベロタイプ'}
        selectedLabel={tongue.label}
        objects={tongues}
        handleChange={handle.tongue}
        description={openingPattern.value === 'unselected' ? '履き口パターンを先に選択してください。' : ''}
        isError={tongue.value === 'unselected'}
      />
      <SelectCard
        summary="ラインカラータイプ"
        selectedLabel={lineType.label}
        objects={LINE_TYPES}
        handleChange={handle.lineType}
        isError={lineType.value === 'unselected'}
      />
      <SelectCard
        summary={'P革加工の有無'}
        selectedLabel={toeGuard.label}
        objects={TOE_GUARDS}
        handleChange={handle.toeGuard}
        isError={toeGuard.value === 'unselected'}
      />
      <SelectCard
        summary={'P革加工の種類'}
        selectedLabel={toeGuardKind.label}
        objects={toeGuardKinds}
        handleChange={handle.toeGuardKind}
        isDisplay={!['none', 'unselected'].includes(toeGuard.value)}
        disabled={outSole.value === 'unselected'}
        description={outSole.value === 'unselected' ? '先にソールを選択してください。' : ''}
        isError={toeGuardKind.value === 'unselected'}
      />
    </TabPanel>
  )
}
